import { render, staticRenderFns } from "./SingleDistroCenter.vue?vue&type=template&id=3835a5a2&scoped=true"
import script from "./SingleDistroCenter.vue?vue&type=script&lang=js"
export * from "./SingleDistroCenter.vue?vue&type=script&lang=js"
import style0 from "./SingleDistroCenter.vue?vue&type=style&index=0&id=3835a5a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3835a5a2",
  null
  
)

export default component.exports